import {Inject, Injectable} from '@angular/core';
import {HttpService} from '@tisa-group/cdk';
import {TISA_AUTH_URL} from './tisa-auth.providers';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class TisaAuthHttpService extends HttpService {
  constructor(@Inject(TISA_AUTH_URL) readonly api: string, readonly http: HttpClient) {
    super();
  }
}
